import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import Cookies from "js-cookie";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import DatePicker from "react-date-picker";
import moment from "moment";
import { NavLink, useNavigate } from "react-router-dom";
import MaterialChart from "./Charts/MaterialChart";
import ConsumedProductChart from "./Charts/ConsumedProductChart";
import MisReport from "../Manufacturing/MisReport/MisReport";
import YardMisReport from "../Manufacturing/MisReport/YardMisReport";
import ScrollToTop from "react-scroll-to-top";
import Typewriter from "typewriter-effect";
import CountUp from "react-countup";
import ProductChart from "./Charts/ProductChart";
import OrderStatus from "./OrderStatus";
import SupplyStatus from "./SupplyStatus";
import DispatchDetailsStatus from "./DispatchDetailsStatus";
import AOS from "aos";
import "aos/dist/aos.css";
import TripDispatchStatus from "./TripDispatchStatus";
import YardWiseMisReport from "../Manufacturing/MisReport/YardWiseMisReport";
const DashBoard = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  });
  const token = Cookies.get("token")?.replace(/"/g, "");
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [companyId, setCompanyId] = useState("");
  const [companyIdMould, setCompanyIdMould] = useState("");
  const [company, setCompany] = useState([]);
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedCompany, setSelectedCompany] = useState("");
  const [productData, setProductData] = useState("");
  const [productMouldData, setProductMouldData] = useState("");
  const [previous, setPrevious] = useState("");
  const [openMisReport, setOpenMisReport] = useState(false);
  const [openYardMisReport, setOpenYardMisReport] = useState(false);
  const [openYardWiseReport, setOpenYardWiseReport] = useState(false);
  const [showProduct, setShowProduct] = useState(false);
  const [showMaterial, setShowMaterial] = useState(true);
  const [showOrder, setShowOrder] = useState(false);
  const [showSupply, setShowSupply] = useState(false);
  const [showDispatch, setShowDispatch] = useState(false);
  const [showTripStatus, setShowTripStatus] = useState(false);
  const [getProduct, setGetProduct] = useState(false);
  const [productStatus, setProductStatus] = useState(false);
  const getCompany = async () => {
    let BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      const combinedComp = result.data?.map((data) => ({
        companyName: data.company_name,
        location: data.location,
        type: data.type,
        id: data.id,
      }));
      setCompany(combinedComp);
    } else {
    }
  };

  useEffect(() => {
    getCompany();
  }, []);
  useEffect(() => {
    if (company?.length > 0) {
      setCompanyIdMould(company[0].id);
      setCompanyId(company[0].id);
    }
  }, [company]);

  const handleCompanyChange = (e) => {
    setCompanyId(e.target.value);
  };
  const handleCompanyChangeForMould = (e) => {
    setCompanyIdMould(e.target.value);
  };

  const currentQueryDate = moment(selectedDate).format("YYYY-MM-DD");

  const getProductQuantity = async () => {
    const renewalDate = moment(selectedDate).format("DD-MM-YYYY");
    let BASE_URL =
      SERVER_URL +
      `/api/product-details/product-quantity/${user_id}?date=${renewalDate}&timeRange=${previous}&company_id=${companyId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setProductData(result.data);
      setProductStatus(true);
    } else {
      setProductData([]);
    }
  };

  useEffect(() => {
    getProductQuantity();
  }, [selectedDate, previous, companyId]);

  const getProductMouldQuantity = async () => {
    const renewalDate = moment(selectedDate).format("DD-MM-YYYY");
    let BASE_URL =
      SERVER_URL +
      `/api/product-details/product-mould-quantity/${user_id}?date=${renewalDate}&timeRange=${previous}&company_id=${companyIdMould}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setProductMouldData(result.data);
      setGetProduct(true);
    } else {
      setProductMouldData([]);
    }
  };

  useEffect(() => {
    getProductMouldQuantity();
  }, [selectedDate, companyIdMould]);

  const handleDaysChange = (e) => {
    // console.log(e.target.value);
    setPrevious(e.target.value);
  };
  useEffect(() => {
    const storedTab = Cookies.get("selectedTab");
    if (storedTab) {
      const parsedTab = JSON.parse(storedTab);
      setShowMaterial(parsedTab.showMaterial);
      setShowProduct(parsedTab.showProduct);
      setShowOrder(parsedTab.showOrder);
      setShowSupply(parsedTab.showSupply);
      setShowDispatch(parsedTab.showDispatch);
      setShowTripStatus(parsedTab.showTripStatus);
    }
  }, []);
  const handleSwitchTabs = (tab) => {
    if (tab === "material") {
      setShowMaterial(true);
      setShowProduct(false);
      setShowOrder(false);
      setShowSupply(false);
      setShowDispatch(false);
      setShowTripStatus(false);
    } else if (tab === "product") {
      setShowTripStatus(false);
      setShowMaterial(false);
      setShowOrder(false);
      setShowSupply(false);
      setShowDispatch(false);
      setShowProduct(true);
    } else if (tab === "order") {
      setShowTripStatus(false);
      setShowMaterial(false);
      setShowProduct(false);
      setShowSupply(false);
      setShowDispatch(false);
      setShowOrder(true);
    } else if (tab === "supply") {
      setShowTripStatus(false);
      setShowMaterial(false);
      setShowProduct(false);
      setShowOrder(false);
      setShowDispatch(false);
      setShowSupply(true);
    } else if (tab === "dispatch") {
      setShowTripStatus(false);
      setShowMaterial(false);
      setShowProduct(false);
      setShowOrder(false);
      setShowSupply(false);
      setShowDispatch(true);
    } else if (tab === "trip") {
      setShowTripStatus(true);
      setShowMaterial(false);
      setShowProduct(false);
      setShowOrder(false);
      setShowSupply(false);
      setShowDispatch(false);
    }
    Cookies.set(
      "selectedTab",
      JSON.stringify({
        showMaterial: tab === "material" ? true : false,
        showProduct: tab === "product" ? true : false,
        showOrder: tab === "order" ? true : false,
        showSupply: tab === "supply" ? true : false,
        showDispatch: tab === "dispatch" ? true : false,
        showTripStatus: tab === "trip" ? true : false,
      })
    );
  };

  return (
    <>
      <div className="container-scroller">
        <ScrollToTop smooth color="#e94202" style={{ marginRight: "20px" }} />
        <div className="content-wrapper" data-aos="fade-in">
          <div className="row ">
            <div className="col-md-12 grid-margin">
              <div className="heading-content d-flex justify-content-between flex-wrap">
                <div className="d-flex align-items-end flex-wrap">
                  <div className="mr-md-3 mr-xl-5">
                    <h2 className="typewriter-header">
                      <Typewriter
                        options={{
                          strings: [
                            "<span style='color:  #5438af;'>Welcome Back...</span>",
                            "<span style='color: #d2ae6c;'>On KUSUM INDUSTRIES dashboard.</span>",
                          ],
                          autoStart: true, // Disable autoStart
                          loop: true,
                          html: false,
                        }}
                      />
                    </h2>
                  </div>
                </div>
                <div
                  className="d-flex align-items-end flex-wrap"
                  style={{ alignItems: "center" }}
                >
                  <div
                    className="btn-group-vertical"
                    role="group"
                    aria-label="Basic example"
                  >
                    <div className="btn-group">
                      <button
                        type="button"
                        className="btn btn-primary mr-3 mt-xl-0"
                        data-toggle="dropdown"
                      >
                        MIS Report{" "}
                        <i
                          className={`fa ${
                            openMisReport ||
                            openYardMisReport ||
                            openYardWiseReport
                              ? "fa-caret-up"
                              : "fa-caret-down"
                          }`}
                        ></i>
                      </button>
                      <div
                        className="dropdown-menu"
                        style={{ cursor: "pointer" }}
                      >
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            setOpenMisReport(!openMisReport);
                            setOpenYardMisReport(false);
                            setOpenYardWiseReport(false);
                          }}
                        >
                          Material Stock Report
                        </a>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            setOpenYardMisReport(!openYardMisReport);
                            setOpenMisReport(false);
                            setOpenYardWiseReport(false);
                          }}
                        >
                          Stock Yard Report
                        </a>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            setOpenYardWiseReport(!openYardWiseReport);
                            setOpenMisReport(false);
                            setOpenYardMisReport(false);
                          }}
                        >
                          Stock Yard Wise Report
                        </a>
                      </div>
                    </div>
                  </div>

                  {/* <i className="mdi mdi-calendar-multiselect-outline mr-3 icon-lg text-primary"></i> */}
                  <div className="d-flex flex-column justify-content-around">
                    <small className="mb-1 text-muted">Select Date</small>
                    <DatePicker
                      value={selectedDate}
                      onChange={setSelectedDate}
                      className={"form-control date-pick"}
                      format="dd/MM/yyyy"
                      dayAriaLabel="DD"
                      clearIcon={null}
                      dayPlaceholder="DD"
                      monthAriaLabel="MM"
                      monthPlaceholder="MM"
                      yearAriaLabel="YYYY"
                      yearPlaceholder="YYYY"
                      maxDate={new Date()}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {openMisReport && (
            <div className="row mb-3">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <MisReport selectedDate={currentQueryDate} />
                  </div>
                </div>
              </div>
            </div>
          )}
          {openYardMisReport && (
            <div className="row mb-3">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <YardMisReport selectedDate={currentQueryDate} />
                  </div>
                </div>
              </div>
            </div>
          )}
          {openYardWiseReport && (
            <div className="row mb-3">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <YardWiseMisReport selectedDate={currentQueryDate} />
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-md-12 grid-margin stretch-card">
              <div className="card">
                <div className="card-body dashboard-tabs p-0">
                  <ul
                    className="nav nav-tabs px-4 border-left-0 border-top-0 border-right-0"
                    role="tablist"
                  >
                    <li
                      className="nav-item"
                      onClick={() => handleSwitchTabs("material")}
                    >
                      <a
                        className={`nav-link ${showMaterial ? "active" : ""}`}
                        id="material-stock-report-tab"
                        data-toggle="tab"
                        href="#material-stock-report"
                        role="tab"
                        aria-controls="overview"
                        aria-selected={showMaterial ? "true" : "false"}
                      >
                        Materials Stock Report
                      </a>
                    </li>
                    <li
                      className="nav-item"
                      onClick={() => handleSwitchTabs("product")}
                    >
                      <a
                        className={`nav-link ${showProduct ? "active" : ""}`}
                        id="product-stock-report-tab"
                        data-toggle="tab"
                        href="#product-stock-report"
                        role="tab"
                        aria-controls="sales"
                        aria-selected={showProduct ? "true" : "false"}
                      >
                        Product Stock Report
                      </a>
                    </li>
                    <li
                      className="nav-item"
                      onClick={() => handleSwitchTabs("order")}
                    >
                      <a
                        className={`nav-link ${showOrder ? "active" : ""}`}
                        id="order-tab"
                        data-toggle="tab"
                        href="#order-details"
                        role="tab"
                        aria-controls="sales"
                        aria-selected={showOrder ? "true" : "false"}
                      >
                        Order Details Summary
                      </a>
                    </li>
                    <li
                      className="nav-item"
                      onClick={() => handleSwitchTabs("supply")}
                    >
                      <a
                        className={`nav-link ${showSupply ? "active" : ""}`}
                        id="supply-tab"
                        data-toggle="tab"
                        href="#supply-details"
                        role="tab"
                        aria-controls="sales"
                        aria-selected={showSupply ? "true" : "false"}
                      >
                        Supply Details Summary
                      </a>
                    </li>
                    <li
                      className="nav-item"
                      onClick={() => handleSwitchTabs("dispatch")}
                    >
                      <a
                        className={`nav-link ${showDispatch ? "active" : ""}`}
                        id="dispatch-tab"
                        data-toggle="tab"
                        href="#dispatch-details"
                        role="tab"
                        aria-controls="sales"
                        aria-selected={showDispatch ? "true" : "false"}
                      >
                        Dispatch Details Summary
                      </a>
                    </li>
                    <li
                      className="nav-item"
                      onClick={() => handleSwitchTabs("trip")}
                    >
                      <a
                        className={`nav-link ${showTripStatus ? "active" : ""}`}
                        id="trip-tab"
                        data-toggle="tab"
                        href="#trip-dispatch-details"
                        role="tab"
                        aria-controls="sales"
                        aria-selected={showTripStatus ? "true" : "false"}
                      >
                        Trip Details Summary
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content py-0 px-0 border-left-0 border-bottom-0 border-right-0">
                    <div
                      className="tab-pane fade show active"
                      id="overview"
                      role="tabpanel"
                      aria-labelledby="overview-tab"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {showProduct && (
            <div className="row mb-3 product_container" data-aos="fade-in">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div>
                      <div
                        style={{
                          justifyContent: "space-between",
                          display: "flex",
                        }}
                      >
                        <p className="card-title">Product Mould Details</p>
                        <div style={{ display: "flex" }}>
                          <select
                            className="form-control ml-2"
                            onChange={handleCompanyChangeForMould}
                            value={companyIdMould}
                          >
                            <option value="">Select Company (All)</option>
                            {company &&
                              company?.length > 0 &&
                              company?.map((item, id) => {
                                return (
                                  <option
                                    key={id}
                                    value={item.id}
                                  >{`${item.companyName}, ${item.location}`}</option>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                      <div className="row">
                        {productMouldData && productMouldData?.length > 0 ? (
                          productMouldData?.map((item, index) => {
                            return (
                              <div className="col-md-3 col-sm-4" key={index}>
                                <div className="d-flex border-md-right flex-grow-1  p-3 item">
                                  <i
                                    className={`mdi ${
                                      index % 2 === 0
                                        ? "mdi-chart-bar"
                                        : "mdi-transmission-tower"
                                    }  menu-icon mr-4 icon-lg dashboard-icon`}
                                  ></i>
                                  <div className="d-flex flex-column justify-content-around">
                                    <small className="mb-1 text-muted">
                                      {item.size}
                                    </small>
                                    <h2>
                                      <CountUp
                                        end={item.totalQuantity}
                                        duration={2}
                                        separator=","
                                      />
                                    </h2>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <>
                            <p>Select Company to view data</p>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {showMaterial && (
            <div className="row mb-3 material_container" data-aos="fade-in">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div>
                      <div className="product-card">
                        <p className="card-title">Product Details</p>
                        <div className="card-select-company">
                          <select
                            value={previous}
                            className="form-control"
                            onChange={handleDaysChange}
                            style={{ width: "auto" }}
                          >
                            <option value="">Select Duration</option>
                            <option value="7 days">7 days</option>
                            <option value="1 month">1 month</option>
                            <option value="3 months">3 months</option>
                            <option value="6 months">6 months</option>
                            <option value="1 year">1 year</option>
                          </select>
                          <select
                            className="form-control ml-2"
                            onChange={handleCompanyChange}
                            value={companyId}
                          >
                            <option value="">Select Company (All)</option>
                            {company &&
                              company.length > 0 &&
                              company.map((item, id) => (
                                <option
                                  key={id}
                                  value={item.id}
                                >{`${item.companyName}, ${item.location}`}</option>
                              ))}
                          </select>
                        </div>
                      </div>
                      {companyId ? (
                        <div className="row">
                          {productData && productData.length > 0 ? (
                            productData.map((item, index) => (
                              <div className="col-md-3 col-sm-4" key={index}>
                                <div className="d-flex border-md-right flex-grow-1 p-3 item">
                                  <i
                                    className={`mdi ${
                                      index % 2 === 0
                                        ? "mdi-chart-bar"
                                        : "mdi-transmission-tower"
                                    } menu-icon mr-4 icon-lg dashboard-icon`}
                                  ></i>
                                  <div className="d-flex flex-column justify-content-around">
                                    <small className="mb-1 text-muted">
                                      {item.size}
                                    </small>
                                    <h2>
                                      <CountUp
                                        end={item.totalQuantity}
                                        duration={2}
                                        separator=","
                                      />
                                    </h2>
                                  </div>
                                </div>
                              </div>
                            ))
                          ) : (
                            <p>No data available</p>
                          )}
                        </div>
                      ) : (
                        <p>Select Company to view data</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showMaterial && (
            <div className="row" data-aos="fade-in">
              {company &&
                company?.length > 0 &&
                company?.map((items, index) => {
                  return (
                    <React.Fragment key={index}>
                      <MaterialChart
                        companyId={items.id}
                        companyName={items.companyName}
                        companyLocation={items.location}
                        companyType={items.type}
                        user_id={user_id}
                        selectedDate={selectedDate}
                      />
                    </React.Fragment>
                  );
                })}
            </div>
          )}
          {showProduct && (
            <div className="row" data-aos="fade-in">
              {company &&
                company?.length > 0 &&
                company?.map((items, index) => {
                  return (
                    <React.Fragment key={index}>
                      <ProductChart
                        companyId={items.id}
                        companyName={items.companyName}
                        companyLocation={items.location}
                        companyType={items.type}
                        user_id={user_id}
                        selectedDate={selectedDate}
                      />
                    </React.Fragment>
                  );
                })}
            </div>
          )}
          {showOrder && (
            <div data-aos="fade-in">
              <OrderStatus
                selectedDate={selectedDate}
                companyDetails={company}
              />
            </div>
          )}
          {showSupply && (
            <div data-aos="fade-in">
              <SupplyStatus
                selectedDate={selectedDate}
                companyDetails={company}
              />
            </div>
          )}
          {showDispatch && (
            <div data-aos="fade-in">
              <DispatchDetailsStatus
                selectedDate={selectedDate}
                companyDetails={company}
              />
            </div>
          )}
          {showTripStatus && (
            <div data-aos="fade-in">
              <TripDispatchStatus
                selectedDate={selectedDate}
                companyDetails={company}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DashBoard;
